import Vue from "vue";
import Vuex from "vuex";
// import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const snackbar = {
  namespaced: true,
  state: () => ({
    content: "",
    color: "",
  }),
  mutations: {
    showMessage(state, payload) {
      state.content = payload.content;
      state.color = payload.color;
    },
  },
};

export default new Vuex.Store({
  state: {
    auth: false,
    department: false,
    Useremail: "",
    corpid: null,
    userid: "",
    VerificatnStatus: "",
    Inwrkflow: "",
    dialogcheck: false,
    session: "",
    fundcount: "",
    Cusdetails: {},
    Refdetails: {},
    expensecount1: "",
    expensecount2: "",
    expenserecovercount: "",
    DisplayStatus: "",
    cardcount: "",
    apiCredentials: {
      baseUrl: "https://corporate.glyd.my",
      // baseUrl: "https://corporate.glyd.my",
      isEncrypted: 1,
    },
    buildValue: null,
    viewer: false,
    approver: false,
    maker: false,
    checker: false,
  },
  modules: { snackbar },
  // plugins: [createPersistedState()],

  mutations: {
    set_build_value(state, buildValue) {
      state.buildValue = buildValue;
    },
    SET_AUTH(state, status) {
      state.auth = status;
    },
    SET_Department(state, status) {
      state.department = status;
    },
    SET_session(state, status) {
      state.session = status;
    },
    SET_USEREMAIL(state, email) {
      state.Useremail = email;
    },
    SET_corpid(state, corpid) {
      state.corpid = corpid;
    },
    SET_userid(state, userid) {
      state.userid = userid;
    },
    SET_Cusdetails(state, custdet) {
      state.Cusdetails = custdet;
    },
    SET_refdetails(state, refr) {
      state.Refdetails = refr;
    },
    SET_VerificatnStatus(state, VerStatus) {
      state.VerificatnStatus = VerStatus;
    },
    SET_InWrkFlow(state, inwrkflow) {
      state.Inwrkflow = inwrkflow;
    },
    SET_dialogcheck(state, check) {
      state.dialogcheck = check;
    },

    SET_display(state, display) {
      state.DisplayStatus = display;
    },
    SET_FundCount(state, fund) {
      state.fundcount = fund;
    },
    SET_ExpenseCount1(state, expense1) {
      state.expensecount1 = expense1;
    },
    SET_ExpenseCount2(state, expense2) {
      state.expensecount2 = expense2;
    },
    SET_ExpenseRecoverCount(state, expenserecover) {
      state.expenserecovercount = expenserecover;
    },
    SET_Requestcards(state, cardcnt) {
      state.cardcount = cardcnt;
    },
    SET_viewer(state, viewer) {
      state.viewer = viewer;
    },
    SET_maker(state, viewer) {
      state.viewer = viewer;
    },
    SET_checker(state, viewer) {
      state.viewer = viewer;
    },
    SET_approver(state, viewer) {
      state.viewer = viewer;
    },
  },
  getters: {
    get_build_value: (state) => {
      return state.buildValue;
    },
    get_auth: (state) => {
      return state.auth || false;
    },

    get_Department: (state) => {
      return state.department;
    },
    get_session: (state) => {
      return state.session;
    },
    get_useremail: (state) => {
      return state.Useremail;
    },
    get_corpid: (state) => {
      return state.corpid;
    },
    get_userid: (state) => {
      return state.userid;
    },
    get_VerificatnStatus: (state) => {
      return state.VerificatnStatus;
    },
    get_display: (state) => {
      return state.DisplayStatus;
    },
    get_InWrkflow: (state) => {
      return state.Inwrkflow;
    },
    get_getCustDetails: (state) => {
      return state.Cusdetails;
    },
    get_getRefDetails: (state) => {
      return state.Refdetails;
    },

    get_dialogcheck: (state) => {
      return state.dialogcheck;
    },
    get_FundCount: (state) => {
      return state.fundcount;
    },
    get_ExpenseCount1: (state) => {
      return state.expensecount1;
    },
    get_ExpenseCount2: (state) => {
      return state.expensecount2;
    },
    get_ExpenseRecoverCount: (state) => {
      return state.expenserecovercount;
    },
    get_Requestcards: (state) => {
      return state.cardcount;
    },
    getApiCredentials: (state) => {
      return state.apiCredentials;
    },
    get_viewer: (state) => {
      return state.viewer;
    },
    get_maker: (state) => {
      return state.maker;
    },
    get_checker: (state) => {
      return state.checker;
    },
    get_approver: (state) => {
      return state.approver;
    },
  },
  actions: {},
});
